import React, { useState } from "react"
import PropTypes from 'prop-types'
import 'reactjs-popup/dist/index.css'

import { Translate } from "../Translator"

//VoIPCenter does not allow changing settings in the Phone API

const TelephonySettingsTeams = (props) => {

    return (
        <span>
            <div className="smalltext">{Translate("Linked to the teams account configured in the CloudCTI Teams app")}</div>
        </span>
    )
}

TelephonySettingsTeams.propTypes = {
    PhoneSettings: PropTypes.object,
    OnUpdatePhoneSettings: PropTypes.func
}

export default TelephonySettingsTeams